// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2B-vU","col":"CardReaderDesc_col__2IQDq","label":"CardReaderDesc_label__16iQG"};